module.exports = __webpack_public_path__ + "favicon-270x270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon-270x270.png
// module id = 1817
// module chunks = 0